import { CAMPAIGN_LIST_TYPE } from '@/schemas/v2/campaign'

/**
 * スポット一覧ページで「ページ表示時に」位置情報を取得するかどうかのポリシー（#3583）。
 *
 * - `pending`: キャンペーン情報が未ロードで、まだ判断できない（測位を開始しない）
 * - `fetch`:   マップを表示する（listType = MAP_AND_LIST / MAP / null）→ 従来どおり表示時に測位する
 * - `skip`:    マップを表示しない（listType = LIST）→ 表示時は測位しない。
 *              ARフォト／音声ガイドで必要になったときだけ requestLocation() で測位する
 */
export type GeoLocationPolicy = 'pending' | 'fetch' | 'skip'

type CampaignListTypeSource = { listType: number | null }

export const resolveGeoLocationPolicy = (campaign: CampaignListTypeSource | null): GeoLocationPolicy => {
  if (campaign === null) return 'pending'
  // null は未設定＝MAP_AND_LIST（features/pages/spots/list.tsx の既定と揃える）
  const listType = campaign.listType ?? CAMPAIGN_LIST_TYPE.MAP_AND_LIST
  return listType === CAMPAIGN_LIST_TYPE.LIST ? 'skip' : 'fetch'
}
